<template>
  <div class="ele-body">
    <el-card shadow="never">
      <!-- 搜索表单 -->
      <el-form :model="table.where" label-width="77px" :inline="true" @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
        <el-form-item label="时间">
          <el-date-picker
            v-model="dateRange"
            style="width: 260px"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="onDateRangeChoose"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="small" @click="$refs.table.reload()">搜索</el-button>
          <el-button icon="el-icon-refresh" size="small" @click="(table.where = {}) && (dateRange = []) && $refs.table.reload()">重置</el-button>
        </el-form-item>
      </el-form>
      <ele-data-table ref="table" :config="table" highlight-current-row>
        <template>
          <el-table-column label="序号" width="60" type="index" align="center"></el-table-column>
          <el-table-column label="大类" prop="tagName" align="center" />
          <el-table-column label="小类" prop="normName" align="center" />
          <el-table-column label="年级" prop="gradeName" align="center" />
          <el-table-column label="班级" prop="className" align="center" />
          <el-table-column label="分数" prop="score" align="center" />
          <el-table-column label="已提交人数" prop="choiceNum" align="center" />
          <el-table-column label="未提交人数" prop="notChoiceNum" align="center" />
          <el-table-column label="总人数" prop="total" align="center" />
          <el-table-column label="创建时间" align="center" prop="createTime" min-width="110">
            <template #default="{ row }">{{ row.createTime | toDateString }}</template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="250">
            <template #default="{ row }">
              <el-link @click="openDetail(row)" icon="el-icon-view" type="primary" :underline="false">查看详情</el-link>
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
    </el-card>

    <!--详情弹窗-->
    <el-dialog title="详情" :visible.sync="showDetail" width="400px" :destroy-on-close="true" custom-class="ele-dialog-form" :lock-scroll="false">
      <ele-data-table ref="detailTable" :config="detailTable" highlight-current-row>
        <template>
          <el-table-column label="序号" width="60" type="index" align="center"></el-table-column>
          <el-table-column label="学生姓名" prop="studentName" align="center" />
          <el-table-column label="状态" align="center" prop="createTime">
            <template slot-scope="scope">
              <el-tag :type="scope.row.type == 0 ? 'danger' : 'success'">{{ scope.row.type == 0 ? '未提交' : '已提交' }}</el-tag>
            </template>
          </el-table-column></template
        >
      </ele-data-table>
    </el-dialog>
  </div>
</template>
<script>
  import { getAllItemList } from '@/config/ipadComputer/tag';
  export default {
    name: 'department',
    data() {
      return {
        table: {
          // 表格配置
          url: '/classRoom/classSignList',
          method: 'GET',
          where: {},
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            res.count = res.data.total;
            res.data = res.data.records;
            return res;
          },
        },
        dateRange: [],
        showDetail: false,
        detailTable: {
          // 表格配置
          url: '/classRoom/classSignDetailList',
          method: 'GET',
          where: {
            id: null,
          },
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            res.count = res.data.total;
            res.data = res.data.records;
            return res;
          },
        },
        normList: [],
      };
    },
    created() {
      this.getItemList();
    },
    methods: {
      /* 日期选择改变回调 */
      onDateRangeChoose() {
        if (this.dateRange) {
          this.table.where.beginTime = this.dateRange[0];
          this.table.where.endTime = this.dateRange[1];
        } else {
          this.table.where.beginTime = null;
          this.table.where.endTime = null;
        }
      },
      // 获取小类
      getItemList() {
        getAllItemList().then((res) => {
          if (res.data.resCode == 200) {
            this.normList = res.data.data;
          }
        });
      },
      // 查看详情
      openDetail(row) {
        this.detailTable.where.id = row.id;
        this.showDetail = true;
        this.$refs.detailTable.reload();
      },
    },
  };
</script>

<style scoped lang="scss"></style>
